// extracted by mini-css-extract-plugin
export default {"base":"vp_n2FXT","spacingSmall":"vp_lw3XC","spacingMedium":"vp_CYS9H","spacingLarge":"vp_fUvVJ"};